import { useState, useEffect } from "react";
import * as React from 'react';
import axios from "axios";
import isEmail from 'validator/lib/isEmail';
import isStrongPassword from 'validator/lib/isStrongPassword';
import isLength from 'validator/lib/isLength';
import equals from 'validator/lib/equals';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import CircularProgress from '@mui/material/CircularProgress';
import useMediaQuery from '@mui/material/useMediaQuery';
import Link from '@mui/material/Link';
import Breadcrumbs from '@mui/material/Breadcrumbs';

import { Swiper } from 'swiper/react';
import { SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import "./../assets/swiperCss.css";
import 'swiper/css/autoplay';

const widthPageSlide = 600;

const config = require("../../constants/constants.js")
const enableCreateAccount = config.ENABLE_CREATE_ACCOUNT;

const RegisterPageComponent = ({
  registerUserApiRequest,
  reduxDispatch,
  setReduxUserState,
}) => {

  const [validated, setValidated] = useState(false);
  const [registerUserResponseState, setRegisterUserResponseState] = useState({
    success: "",
    error: "",
    loading: false,
  });
  const [passwordsMatchState, setPasswordsMatchState] = useState(true);
  const [showAlertRegister, setShowAlertRegister] = useState(false);

  const onChange = () => {
    const password = document.querySelector("input[name=password]");
    const confirmPassword = document.querySelector("input[name=confirmPassword]");
    if (confirmPassword.value === password.value) {
      setPasswordsMatchState(true);
    } else {
      setPasswordsMatchState(false);
    }
  };

  const handleRegister = (e) => {

    e.preventDefault();

    setShowAlertRegister(true);

    console.log('[handleRegister] isEmail(email)=', isEmail(email));
    console.log('[handleRegister] password =', password);
    console.log('[handleRegister] repassword =', repassword);
    console.log('[handleRegister] password===repassword =', password === repassword);
    console.log('[handleRegister] isEmail(email)=', isEmail(email));

    if (
      name &&
      lastName &&
      email &&
      password &&
      repassword &&
      (password === repassword)
    ) {

      console.log('[handleRegister] creo nuovo utente');

      setRegisterUserResponseState({ loading: true });

      registerUserApiRequest(name, lastName, email, password, false)
        .then((data) => {
          setRegisterUserResponseState({
            success: data.success,
            loading: false,
          });
          reduxDispatch(setReduxUserState(data.userCreated));

        })
        .catch((er) =>
          setRegisterUserResponseState({
            error: er.response.data.message
              ? er.response.data.message
              : er.response.data,
          })
        );
    }

    setValidated(true);
  };

  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [repassword, setRepassword] = useState("");
  const [role, setRole] = useState("");

  const [fieldNameError, setFieldNameError] = useState(false);
  const [fieldLastnameError, setFieldLastnameError] = useState(false);
  const [fieldEmailError, setFieldEmailError] = useState(false);
  const [fieldPasswordError, setFieldPasswordError] = useState(false);
  const [fieldRePasswordError, setFieldRePasswordError] = useState(false);

  const [errorMessage, setErrorMessage] = useState('')

  const [page, setPage] = useState({});
  const [id, setId] = useState("");
  const [title, setTitle] = useState("");
  const [subTitle, setSubTitle] = useState("");
  const [description, setDescription] = useState("");
  const [customizedName, setCustomizedName] = useState("");
  const [customizedStreet, setCustomizedStreet] = useState("");
  const [customizedZip, setCustomizedZip] = useState("");
  const [customizedCity, setCustomizedCity] = useState("");
  const [customizedEmail, setCustomizedEmail] = useState("");
  const [tabAttivo, setTabAttivo] = React.useState('home');
  const [pathImage0, setPathImage0] = useState("");
  const [titleImage0, setTitleImage0] = useState("");
  const [subTitleImage0, setSubTitleImage0] = useState("");
  
  const getPageByMenuValueApiRequest = async (menuValue) => {
    console.log("[getPageByMenuValueApiRequest] leggo page con menuValue =", menuValue);
    const url = `/api/pages/menuValue/` + menuValue;
    const { data } = await axios.get(url);
    //console.log(`data =`, data);
    return data
  }


  useEffect(() => {
    getPageByMenuValueApiRequest('ACCOUNT').then((data) => {
      //console.log(`data 1 =`, data);
      setPage(data);
      setTitle(data?.title.text);
      setSubTitle(data?.subTitle.text);
      setDescription(data?.description.text);
      setTabAttivo('home');
      setId(data?._id);
      setCustomizedName(page?.customizedContent.name.text);
      setCustomizedStreet(page?.customizedContent.street.text);
      setCustomizedZip(page?.customizedContent.zip.text);
      setCustomizedCity(page?.customizedContent.city.text);
      setCustomizedEmail(page?.customizedContent.email.text);
      setPathImage0(data?.images[0].path);
      setTitleImage0(data?.imagesTitle[0].text);
      setSubTitleImage0(data?.imagesSubTitle[0].text);
      //console.log(`id =`, id);
      //console.log(`page?.title.text =`, page?.title.text);
      //console.log(`page?.description.text =`, page?.description.text);
      //console.log(`page?.customizedContent =`, page?.customizedContent);
      //console.log(`page?.customizedContent.name.text =`, page?.customizedContent.zip.text);
    })
      .catch((er) => {
        console.log(er);
      });
  }, [tabAttivo, id])

  return (

    <Box sx={{ flexGrow: 1 }}>

      <Breadcrumbs separator="›" aria-label="breadcrumb"
        size={{ xs: 12, md: 4 }}
        paddingTop={{ xs: 1, md: 1 }}
        paddingLeft={{ xs: 2, md: 6 }}
        paddingRight={{ xs: 1, md: 8 }}
        spacing={{ xs: 2, md: 2 }}
      >
        <Link underline="hover" color="inherit" href="/">
          <Typography
            sx={{
              color: 'text.primary',
              fontFamily: 'Roboto',
              textTransform: 'none',
              fontSize: 14,
            }}
          >
            {config.BC_HOME}
          </Typography>
        </Link>
        <Typography
          sx={{
            color: 'text.primary',
            fontFamily: 'Roboto',
            textTransform: 'none',
            fontSize: 14,
          }}
        >
          {config.BC_CREAACCOUNT}
        </Typography>
      </Breadcrumbs>

      <Grid container spacing={{ xs: 0, md: 2 }}>

        <Grid
          size={{ xs: 0, md: 0 }}
        >
        </Grid>

        <Grid
          size={{ xs: 12, md: 5 }}
          padding={{ xs: 0, md: 4 }}
        >

          <Box sx={{ width: { md: widthPageSlide } }}>

               <Swiper
                  style={{
                    '--swiper-navigation-color': '#fff',
                  }}

                  loop={true}
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false
                  }}

                  lazy={true}
                  pagination={{
                    clickable: true,
                  }}
                  navigation={true}
                  modules={[Pagination, Navigation, Autoplay]}
                  className="image-dim"
                >

                  <SwiperSlide>
                    <img
                      src={pathImage0}
                      loading="lazy"
                    />
                    <div class="text-overlay">
                      <p>
                        <Typography variant="h6" color='#ffffff'
                          sx={{
                            paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1,
                            p: 0, m: 0,
                          }}
                        >
                          {titleImage0}
                        </Typography>
                      </p>
                      <p>
                        <Typography variant="h7" color='#dfdfde'
                          sx={{
                            paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 1,
                            p: 0, m: 0,
                          }}
                        >
                          {subTitleImage0}
                        </Typography>
                      </p>
                    </div>
                    <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                  </SwiperSlide>

                  {page.images?.map((itemImg, id) => (

                    (id > 0 &&

                      <SwiperSlide>
                        <img
                          src={itemImg.path}
                          loading="lazy"
                        />
                        <div class="text-overlay">
                          <p>
                            <Typography variant="h6" color='#ffffff'
                              sx={{
                                paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1,
                                p: 0, m: 0,
                              }}
                            >
                              {itemImg.title}
                            </Typography>
                          </p>
                          <p>
                            <Typography variant="h7" color='#dfdfde'
                              sx={{
                                paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 1,
                                p: 0, m: 0,
                              }}
                            >
                              {itemImg.subTitle}
                            </Typography>
                          </p>
                        </div>
                        <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                      </SwiperSlide>

                    )
                  ))}

                </Swiper>
                
            {/* 

            {!useMediaQuery('(min-width:600px)') &&
              <Swiper
                style={{
                  '--swiper-navigation-color': '#fff',
                  '--swiper-pagination-color': '#fff',
                }}

                lazy={true}
                pagination={{
                  clickable: true,
                }}
                navigation={true}
                modules={[Pagination, Navigation]}
                className="image-dim"
              >

                {page.images?.map((itemImg, id) => (

                  <SwiperSlide>
                    <img
                      src={itemImg.path}
                      loading="lazy"
                    />
                    <div class="text-overlay">
                      <p>
                        <Typography variant="h6" color='#ffffff'
                          sx={{
                            paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1,
                            p: 0, m: 0,
                          }}
                        >
                          {itemImg.title}
                        </Typography>
                      </p>
                      <p>
                        <Typography variant="h7" color='#dfdfde'
                          sx={{
                            paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 1,
                            p: 0, m: 0,
                          }}
                        >
                          {itemImg.subTitle}
                        </Typography>
                      </p>
                    </div>
                    <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                  </SwiperSlide>

                ))}

                <SwiperSlide>
                  <img
                    src={pathImage2}
                    loading="lazy"
                  />
                  <div class="text-overlay">
                    <p>
                      <Typography variant="h6" color='#ffffff'
                        sx={{
                          paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1,
                          p: 0, m: 0,
                        }}
                      >
                        {titleImage2}
                      </Typography>
                    </p>
                    <p>
                      <Typography variant="h7" color='#dfdfde'
                        sx={{
                          paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 1,
                          p: 0, m: 0,
                        }}
                      >
                        {subTitleImage2}
                      </Typography>
                    </p>
                  </div>
                  <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                </SwiperSlide>

              </Swiper>
            }
            {useMediaQuery('(min-width:600px)') &&
              <Swiper
                style={{
                  '--swiper-navigation-color': '#fff',
                  '--swiper-pagination-color': '#fff',
                }}

                loop={true}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false
                }}

                lazy={true}
                pagination={{
                  clickable: true,
                }}
                navigation={true}
                modules={[Pagination, Navigation, Autoplay]}
                className="image-dim"
              >

                {page.images?.map((itemImg, id) => (

                  <SwiperSlide>
                    <img
                      src={itemImg.path}
                      loading="lazy"
                    />
                    <div class="text-overlay">
                      <p>
                        <Typography variant="h6" color='#ffffff'
                          sx={{
                            paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1,
                            p: 0, m: 0,
                          }}
                        >
                          {itemImg.title}
                        </Typography>
                      </p>
                      <p>
                        <Typography variant="h7" color='#dfdfde'
                          sx={{
                            paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 1,
                            p: 0, m: 0,
                          }}
                        >
                          {itemImg.subTitle}
                        </Typography>
                      </p>
                    </div>
                    <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                  </SwiperSlide>

                ))}

                <SwiperSlide>
                  <img
                    src={pathImage2}
                    loading="lazy"
                  />
                  <div class="text-overlay">
                    <p>
                      <Typography variant="h6" color='#ffffff'
                        sx={{
                          paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1,
                          p: 0, m: 0,
                        }}
                      >
                        {titleImage2}
                      </Typography>
                    </p>
                    <p>
                      <Typography variant="h7" color='#dfdfde'
                        sx={{
                          paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 1,
                          p: 0, m: 0,
                        }}
                      >
                        {subTitleImage2}
                      </Typography>
                    </p>
                  </div>
                  <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                </SwiperSlide>

              </Swiper>
            }
            */}

          </Box>

        </Grid>

        <Grid
          size={{ xs: 12, md: 4 }}
          marginLeft={{ xs: 2, md: 6 }}
          paddingRight={{ xs: 2, md: 0 }}
          spacing={2}
        >

          <Box
            sx={{
              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
              height: 30
            }}
          />

          <Paper
            sx={{
              paddingTop: 1, paddingBottom: 2, paddingLeft: 2, paddingRight: 2,
              background: '#cce0e6'

            }}
            elevation={6}
          >

            <Typography
              sx={{
                paddingTop: 1, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                fontFamily: 'Arial',
                fontWeight: 500,
                fontSize: 30,
                color: 'navy',
              }}
            >
              <b>{title}</b>
            </Typography>

            <Stack
              sx={{ flexDirection: { xs: "column", md: "column" }, padding: 2 }}
              padding={2}
              spacing={2}
            >

              <TextField id="id-name" label="Nome" variant="outlined" required
                error={fieldNameError}
                onChange={(event) => {
                  setName(event.target.value);
                  if (isLength(event.target.value, { min: 3, max: 15 })) {
                    setFieldNameError(false);
                  } else {
                    setFieldNameError(true);
                  }
                }}
              />

              <TextField id="id-lastName" label="Cognome" variant="outlined" required
                error={fieldLastnameError}
                onChange={(event) => {
                  setLastName(event.target.value);
                  if (isLength(event.target.value, { min: 3, max: 15 })) {
                    setFieldLastnameError(false);
                  } else {
                    setFieldLastnameError(true);
                  }
                }}
              />

              <TextField id="id-email" label="Email" variant="outlined" required
                error={fieldEmailError}
                onChange={(event) => {
                  setEmail(event.target.value);
                  if (isEmail(event.target.value)) {
                    setFieldEmailError(false);
                  } else {
                    setFieldEmailError(true);
                  }
                }}
              />

              <TextField id="id-password" label="Password" variant="outlined" required type="password"
                error={fieldPasswordError}
                onChange={(event) => {
                  setPassword(event.target.value);
                  if (isStrongPassword(event.target.value)) {
                    setFieldPasswordError(false);
                  } else {
                    setFieldPasswordError(true);
                  }
                }}
              />

              <TextField id="id-repassword" label="Ripeti password" variant="outlined" required type="password"
                error={fieldRePasswordError}
                onChange={(event) => {
                  setRepassword(event.target.value);
                  if (isStrongPassword(event.target.value)) {
                    setFieldRePasswordError(false);
                  } else {
                    setFieldRePasswordError(true);
                  }
                }}
              />

              <Box
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  height: 5
                }}
              />
            </Stack>

            <Grid
              container
              spacing={1}
              sx={{
                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 2,
              }}
              justifyContent={"flex-end"}
            >

              <Button type="submit"
                onClick={handleRegister}
                sx={{ maxWidth: "30ch" }}
                variant="contained"
                disabled={!enableCreateAccount}
              >
                {registerUserResponseState &&
                  registerUserResponseState.loading === true ? (
                  <CircularProgress />
                ) : (
                  ""
                )}
                Crea nuovo account
              </Button>
              </Grid>

            <Dialog open={showAlertRegister && registerUserResponseState && registerUserResponseState.error === "user exists"}>
              <Alert
                variant="filled"
                severity="error"
                onClose={() => { setShowAlertRegister(false) }}
              >
                Già esiste un Utente con questa email!
              </Alert>
            </Dialog>
            <Dialog open={showAlertRegister && registerUserResponseState && registerUserResponseState.success === "User created"}>
              <Alert
                variant="filled"
                severity="success"
                onClose={() => { setShowAlertRegister(false) }}
              >
                Utente creato
              </Alert>
            </Dialog>

            <Box
              sx={{
                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                height: 5
              }}
            />

          </Paper>
      
        </Grid>

      </Grid>

      <Box
        sx={{
          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
          height: 30
        }}
      />

    </Box>

  );
};

export default RegisterPageComponent;
